export default {
  common: {
    ADD: 'Add',
    CANCEL: 'Cancel',
    CONFIRM_DELETION: 'Confirm deletion',
    DATA_SAVED_SUCCESFULLY: 'Data saved successfully',
    DELETE: 'Delete',
    EDIT: 'Edit',
    END: 'End',
    ERROR_401: 'Not authorized',
    ERROR_500: 'Internal server error',
    FILES: 'Files',
    IMPORT: 'Import',
    LINKS: 'Links',
    NEXT: 'Next',
    NO: 'No',
    NOT_VALID_ALPHANUMERIC: 'Not valid alphanumeric',
    REQUIRED_FIELD: 'This field is required',
    RESET: 'Reset',
    SAVE: 'Save',
    SEARCH_BY: 'Search By',
    SEARCH: 'Search',
    SHOW_MORE: 'Show More',
    SHOW_MORE_INFO: 'Show More info',
    START: 'Start',
    YES: 'Yes',
  },
};
